import {
  applyAtlasDebugBootstrap,
  parseAtlasDebugSessionFromUrl,
  type AtlasDebugAppAdapter,
  type AtlasDebugRequest,
  type AtlasDebugSession,
} from './debug';

let activeSession: AtlasDebugSession | null = null;
let activeAdapter: AtlasDebugAppAdapter | null = null;

export function initializeAtlasDebugFromWindow(
  adapter: AtlasDebugAppAdapter,
  targetWindow: Window,
): AtlasDebugSession | null {
  const session = parseAtlasDebugSessionFromUrl(targetWindow.location.href, adapter.appId);
  if (!session) {
    return null;
  }

  activeSession = session;
  activeAdapter = adapter;
  applyAtlasDebugBootstrap(targetWindow, adapter.getBootstrap?.(session));
  return session;
}

export function getActiveAtlasDebugSession(): AtlasDebugSession | null {
  return activeSession;
}

export function resolveAtlasDebugResponse(
  request: AtlasDebugRequest,
): ReturnType<NonNullable<AtlasDebugAppAdapter['getMockResponse']>> {
  if (!activeSession || !activeAdapter?.getMockResponse) {
    return undefined;
  }

  return activeAdapter.getMockResponse(request, activeSession);
}
